import Text from './Text';
import Title from './Title';
import Paragraph from './Paragraph';

const Typography: {
  Text: typeof Text;
  Title: typeof Title;
  Paragraph: typeof Paragraph;
} = () => null;

Typography.Text = Text;
Typography.Title = Title;
Typography.Paragraph = Paragraph;

Text.displayName = 'TypographyText';
Title.displayName = 'TypographyTitle';
Paragraph.displayName = 'TypographyParagraph';

export default Typography;
